import { HtmlParser } from '@calendly/html-parser'
import { I18n } from '@calendly/i18n'

export const getMemberName = (member, currentUser) => {
  let { name: memberName } = member
  const memberIsPending = member.isPending || member.is_pending || member.type === 'OrganizationInvitation'
  const memberUserUuid = member.userUuid || member.user_uuid

  if (memberIsPending) {
    return HtmlParser(I18n.t('publisher.event_type_editor.sections.hosts_and_invitees.pending_invitation'))
  }

  if (currentUser.uuid === memberUserUuid) {
    memberName = memberName.concat(I18n.t('publisher.event_types.one_off.creation_modal.details_step.meeting_summary.member_owner'))
  }

  return memberName
}
